/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Site_LockedInputs */

const en_site_url_error_site_locked = /** @type {(inputs: Site_Url_Error_Site_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many blocked addresses. This feature is paused for your account for 30 minutes.`)
};

const id_site_url_error_site_locked = /** @type {(inputs: Site_Url_Error_Site_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlalu banyak alamat yang diblokir. Fitur ini dijeda 30 menit untuk akunmu.`)
};

/**
* | output |
* | --- |
* | "Too many blocked addresses. This feature is paused for your account for 30 minutes." |
*
* @param {Site_Url_Error_Site_LockedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_site_locked = /** @type {((inputs?: Site_Url_Error_Site_LockedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Site_LockedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_site_locked(inputs)
	return en_site_url_error_site_locked(inputs)
});